export default "__VITE_ASSET__kEhoim1g__"